export default __webpack_public_path__ + "static/media/our-team-1.6e2039ab.jpg";